export function checkRegisterCourse  (enrollments,course_id)  {
  console.log(enrollments,course_id);
  return enrollments.find(item => item.course_id == course_id)
}

